import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
export const loadAllAppointments = createAsyncThunk(
  "allAppointments/load",
  async ({ data, pageNo = 1, pageSize = 20 }, { rejectWithValue }) => {
    const tokenString = localStorage.getItem("token");
    let token = tokenString;
    try {
      token = JSON.parse(tokenString);
    } catch {}
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");
    const body = JSON.stringify({
      fromDate: data?.appointmentDate?.[0] || null,
      toDate: data?.appointmentDate?.[1] || null,
      name: data?.name,
      treatment_ids: data?.treatment_ids || "",
      app_status: data?.app_status || "",
      pageNo,
      pageSize,
    });
    const response = await fetch(
      "https://api-qa.hairplusinternational.com/api/viewAllAppointments",
      {
        method: "POST",
        headers: myHeaders,
        body,
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error ! status:${response.status}`);
    }
    const result = await response.json();
    if (!result.success) {
      return rejectWithValue(
        result.message || "Failed to fetch all Appointment"
      );
    }
    return {
      appointments: result.result || [],
      total: result.total || result.result.length,
    };
  }
);
export const removeAppointment = createAsyncThunk(
  "allAppointments/remove",
  async (id, { rejectWithValue, dispatch }) => {
    const tokenString = localStorage.getItem("token");
    let token = tokenString;
    try {
      token = JSON.parse(tokenString);
    } catch {}
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    myHeaders.append("Content-Type", "application/json");
    const response = await fetch(
      `https://api-qa.hairplusinternational.com/api/deleteAppointment/${id}`,
      {
        method: "DELETE",
        headers: myHeaders,
      }
    );
    if (!response.ok) {
      throw new Error(`HTTP error ! status:${response.status}`);
    }
    const result = await response.json();
    if (!result.success) {
      return rejectWithValue(result.message || "Failed to delete appointment");
    }
    // After successful deletion, reload appointments
    dispatch(loadAllAppointments({ data: {}, pageNo: 1, pageSize: 20 }));
    return id;
  }
);
const initialState = {
  dataSource: [],
  filters: {
    name: "",
    appointmentDate: null,
    treatment_ids: "",
    app_status: "",
  },
  pagination: {
    current: 1,
    pageSize: 20,
    total: 0,
  },
  loading: false,
  error: null,
};
const allAppointmentSlice = createSlice({
  name: "allAppointments",
  initialState,
  reducers: {
    changeAllAppointmentsFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.current = 1;
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadAllAppointments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadAllAppointments.fulfilled, (state, action) => {
        state.loading = false;
        state.dataSource = action.payload.appointments;
        state.pagination.total = action.payload.total;
      })
      .addCase(loadAllAppointments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Fail to load Appointments";
      })
      .addCase(removeAppointment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(removeAppointment.fulfilled, (state, action) => {
        state.loading = false;
        // Remove the appointment from dataSource
        state.dataSource = state.dataSource.filter(
          (item) => item.id !== action.payload
        );
        state.pagination.total -= 1;
      })
      .addCase(removeAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Fail to delete appointment";
      });
  },
});
export const { changeAllAppointmentsFilters, setPagination } =
  allAppointmentSlice.actions;
export default allAppointmentSlice.reducer;
